export var escape = (function () {
    var MAP = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&#34;',
        "'": '&#39;'
    };

    var repl = function (c) {
        return MAP[c];
    };

    return function (s) {
        return s.replace(/[&<>'"]/g, repl);
    };
})();

export var plural_en = function(value, s, p) {
    if (value == 1) return s;
    return p;
};

export var plural_fr = function(value, s, p) {
    if (value == 1 || value == 0)  return s;
    return p;
};


// WEBPACK FOOTER //
// ./src/locale/utils.js